<template>
    <div class="section" :style="{backgroundImage:'url('+background+')'}">
        <div :style="{background:(fade || 'transparent')}">
            <div v-if="container" :style="istyle" class="container" :class="{fluid:fluid}">
                <slot/>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "isection",
        props:{
            "fluid":Boolean,
            "background":String,
            "fade":String,
            "container":{
                type:Boolean,
                default:true
            },
            istyle:Object
        },
        computed: {},
        methods: {}
    }
</script>

<style scoped>

    .section{
        background-size: cover;
        background-position: center;
    }

    .container {
        margin-right: auto;
        margin-left: auto;
        padding-left: 15px;
        padding-right: 15px;
    }

    @media (min-width: 768px) {
        .container {
            width: 750px;
        }
    }

    @media (min-width: 992px) {
        .container {
            width: 970px;
        }
    }

    @media (min-width: 1230px) {
        .container {
            width: 1200px;
        }
    }

    .fluid {
        margin-right: auto;
        margin-left: auto;
        padding-left: 15px;
        padding-right: 15px;
    }

</style>